module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Lord-Of-The-Rings-The-Fellowship-Of-The-Ring.934f2c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Lord-Of-The-Rings-The-Fellowship-Of-The-Ring.jpg
// module id = gtBP
// module chunks = 0